// src/components/GoogleMapComponent.js
import React, { useEffect } from 'react';
import { GoogleMap, LoadScript, Marker } from '@react-google-maps/api';
import { useSelector, useDispatch } from 'react-redux';
import { setCenter, setZoom } from '../../../redux/actions/mapActions';
import { google_map_api_key } from '../../../../src/server';
import { toast } from 'react-hot-toast';

// Tailwind CSS container style
const containerStyle = {
  width: '100%',
  height: '500px',
};

const GoogleMapComponent = () => {
  const { center, zoom } = useSelector((state) => state.map);
  const dispatch = useDispatch();

  const fetchLocation = async () => {
    try {
      if (!navigator.geolocation) {
        throw new Error("Geolocation is not supported by this browser.");
      }
      const position = await new Promise((resolve, reject) =>
        navigator.geolocation.getCurrentPosition(resolve, reject)
      );
      return position.coords;
    } catch (error) {
      console.error("Geolocation error:", error);
      return null;
    }};

  // Simulating real-time location tracking (replace with WebSocket/GPS API in production)
  const updateLocation = async () => {
    const coords = await fetchLocation();
    if (!coords) {
      toast.error("Unable to fetch your location. Proceeding without location data.");
    }
    const { latitude: userLatitude = null, longitude: userLongitude = null } = coords || {};
    const newCenter = {
      lat: userLatitude,
      lng: userLongitude,
    };
    dispatch(setCenter(newCenter)); // Update Redux store with new position
    // console.log("newCenter =>> ", newCenter);

    // if (navigator.geolocation) {
    //   navigator.geolocation.watchPosition(
    //     (position) => {
    //       const newCenter = {
    //         lat: position.coords.latitude,
    //         lng: position.coords.longitude,
    //       };
    //       dispatch(setCenter(newCenter)); // Update Redux store with new position
    //     },
    //     (error) => {
    //       // Handle errors gracefully
    //       if (error.code === error.PERMISSION_DENIED) {
    //         alert("Permission denied. Please enable location services.");
    //       } else if (error.code === error.POSITION_UNAVAILABLE) {
    //         alert("Location unavailable. Please ensure GPS is enabled.");
    //       } else if (error.code === error.TIMEOUT) {
    //         alert("Location request timed out. Please try again later.");
    //       } else {
    //         alert("An unknown error occurred.");
    //       }
    //     },
    //     {
    //       enableHighAccuracy: true,
    //       timeout: 100000, // Increased timeout (10 seconds)
    //       maximumAge: 0, // Don't use cached position
    //     }
    //   );
    // } else {
    //   alert("Geolocation is not supported by this browser.");
    // }
  };

  // Initialize the map by setting a default center if there's no position in the Redux store
  useEffect(() => {
    if (!center.lat && !center.lng) {
      const defaultCenter = { lat: 37.7749, lng: -122.4194 }; // Default to San Francisco
      dispatch(setCenter(defaultCenter));
    }
    updateLocation(); // Start tracking location updates
  }, [center, dispatch]);

  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold text-center mb-4">Delivery Person's Current Location</h1>
      <div className="rounded-lg shadow-lg overflow-hidden">
        <LoadScript googleMapsApiKey={google_map_api_key}>
          <GoogleMap
            mapContainerStyle={containerStyle}
            center={center}
            zoom={zoom}
          >
            {/* Marker that moves automatically */}
            <Marker position={center} />
          </GoogleMap>
        </LoadScript>
      </div>
    </div>
  );
};

export default GoogleMapComponent;
